import { isFunction } from 'lodash';

export const reset = (e, callback) => {
  e.preventDefault();
  e.stopPropagation();
  isFunction(callback) && callback(e);
};
